import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

class ViewEnterpriseInformation extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        if (this.props.data != undefined) {

            //Selecciono Empresa o Novedad de Empresa...
            let novedad = this.props.data.novedades.find(x => x.EmpresaId == this.props.data.idEmpresaInformacion)
            let empresa = this.props.data.empresas.find(x => x.Id == this.props.data.idEmpresaInformacion)

            let empresaCategoriaIvaDescripcion = this.props.tarjetas.clienteResultadoBusqueda.iva;

            let limiteCompraFormato = "";
            let rubros = null;
            let mensajeRubro = "";
            let descripcionDomicilio = "";

            if (empresa != undefined) {
                limiteCompraFormato = GlobalHelper.ConvertirNumeroSinDecimales(empresa.LimiteCompra);

                if (novedad != undefined) {
                    empresa.LimiteCompra = novedad.ValorNovedad;
                }

                
                mensajeRubro = empresa.RubroIncluidoExcluido == "I" ? "Rubros en los que puede comprar solamente: " : empresa.RubroIncluidoExcluido == "E" ? "Rubros exceptuados" : "Rubros en los que puede comprar: Todos";

                if (this.props.data.rubros.length > 0) {
                    rubros = this.props.data.rubros.map(function (rubro) {
                        return (
                            <li>{rubro.Descripcion}</li>
                        )
                    });
                }

                descripcionDomicilio = empresa.DomicilioBancoTipo + " - " +
                    empresa.DomicilioCalle + "  " +
                    empresa.DomicilioNumero + ", " +
                    empresa.DomicilioDepartamentoPartido + ", " +
                    empresa.DomicilioCodigoPostal + ", " +
                    "(" + "Cód. geográfico " + (empresa.DomicilioCodigoGeografico != "0" ? empresa.DomicilioCodigoGeografico : empresa.DomicilioCodigoGeograficoInput) + ")" + (empresa.Telefono ?
                    ("- Telefono " + (empresa.Caracteristica || "") + " " + empresa.Telefono + "."):" Teléfono No Disponible.");
            }

            return (

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-8"><label className="label-primary">Denominación de la empresa (para los archivos)</label></div>
                        <div className="col-md-4"><label className="label-primary">Tipo de IVA</label></div>
                    </div>
                    <div className="row">
                        <div className="col-md-8"><label className="label-secondary">{empresa.Denominacion}</label></div>
                        <div className="col-md-4"><label className="label-secondary">{empresaCategoriaIvaDescripcion}</label></div>
                    </div>

                    <div className="row top-separator-xs">
                        <div className="col-md-12"><label className="label-primary">Descripción de la empresa (para identificarla en pantalla)</label></div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"><label className="label-secondary">{empresa.Descripcion}</label></div>
                    </div>

                    <div className="row top-separator-xs">
                        <div className="col-md-12"><label className="label-primary">Domicilio</label></div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"><label className="label-secondary">{descripcionDomicilio}</label></div>
                    </div>

                    <div className="row top-separator-xs">
                        <div className="col-md-12"><label className="label-primary">Destinatario de los reportes</label></div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"><label className="label-secondary">{empresa.DestinatarioReportes}</label></div>
                    </div>

                    {/*<div className="row top-separator-xs">
                        <div className="col-md-12"><label className="label-primary">Telefono</label></div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"><label className="label-secondary">{empresa.Telefono}</label></div>
                    </div>*/}

                    <div className="row top-separator-xs">
                        <div className="col-md-12"><label className="label-primary">Límite de compra</label></div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"><label className="label-secondary">$ {limiteCompraFormato}</label></div>
                    </div>

                    <div className="row top-separator-xs">
                        <div className="col-md-12"><label className="label-primary">Cartera</label></div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"><label className="label-secondary">{empresa.CarteraDescripcion}</label></div>
                    </div>

                    <div className="row top-separator-xs">
                        <div className="col-md-12"><label className="label-primary">{mensajeRubro}</label></div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"><ul>{rubros}</ul></div>
                    </div>

                    <div className="row top-separator-xs">
                        <div className="col-md-12">{empresa.PermiteAdelantos ? <label className="label-secondary"><span className="fa fa-check color-azul-claro" /> Permite Adelantos</label> : null} </div>
                    </div>

                    <div className="row top-separator-xxs">
                        <div className="col-md-12">{empresa.TieneLimiteTransaccion ? <label className="label-secondary"><span className="fa fa-check color-azul-claro" /> Tiene Límite por Transacción </label> : null} </div>
                    </div>

                    <div className="row top-separator-xxs">
                        <div className="col-md-12">{empresa.PermiteConsumosExterior ? <label className="label-secondary"><span className="fa fa-check color-azul-claro" /> Permite consumos en el exterior</label> : null} </div>
                    </div>

                    <div className="row top-separator-xxs">
                        <div className="col-md-12">{empresa.PermiteCuotas ? <label className="label-secondary"> <span className="fa fa-check color-azul-claro" /> Permite cuotas</label> : null} </div>
                    </div>

                    <div className="row top-separator-xxs">
                        <div className="col-md-12">{empresa.GeneraReporteCuentaCentral ? <label className="label-secondary"><span className="fa fa-check color-azul-claro" /> Reporte cuenta central</label> : null} </div>
                    </div>

                    <div className="row top-separator-xxs">
                        <div className="col-md-12">{empresa.TomaGastosModeloLiquidacion ? <label className="label-secondary"> <span className="fa fa-check color-azul-claro" /> Toma los gastos de emisión del resumen del modelo de liquidación</label> : null} </div>
                    </div>

                    <div className="row top-separator-xs">
                        <div className="col-md-5"><label className="label-primary">Bonificación del alta</label></div>
                        <div className="col-md-7"><label className="label-primary">Código de precio de la renovación</label></div>
                    </div>
                    <div className="row">
                        <div className="col-md-5"><label className="label-secondary">{empresa.PorcentajeBonificacionAlta} %</label></div>
                        <div className="col-md-7"><label className="label-secondary">{empresa.TablaPreciosVisaCodigo}</label></div>
                    </div>

                    <div className="row top-separator-xs">
                        <div className="col-md-12"><label className="label-primary">Bonificación de la renovación</label></div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"><label className="label-secondary">{empresa.PorcentajeBonificacion} %</label></div>
                    </div>

                    <div className="row top-separator-xs">
                        <div className="col-lg-5"><label className="label-primary">Vigencia desde el alta</label></div>
                        <div className="col-lg-7"><label className="label-primary">Vigencia desde la renovación</label></div>
                    </div>
                    <div className="row">
                        <div className="col-md-5"><label className="label-secondary">{empresa.VigenciaAlta}</label></div>
                        <div className="col-md-7"><label className="label-secondary">{empresa.VigenciaRenovacion}</label></div>
                    </div>
                    {this.props.ocultarFooter ? null : <GenericSimpleButton text="Cerrar" id="botonAceptar" buttonClass="btn btn-cta" onClick={() => this.props.cerrarModal()} />}
                </div>
            );
        } else {
            return null;
        }
    }

};

export default ViewEnterpriseInformation